module.exports = __webpack_public_path__ + "img/logo10.b34601d7.jpg";